import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';

// import { required } from '../../../utils/validation';
// import RenderInputOrder from '../../input/renderInputOrder';

import ReactModal from 'react-modal';
import { Card } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import {
  makeGetToken,
  makeGetDefaultAccount,
  makeGetAuth,
} from '../../../lib/selector';
import { v4 as uuidv4 } from 'uuid';
import { translate } from 'react-i18next';
const customStyles = {
  content: {
    top: '80px',
    left: '50%',
    width: '500px',
    transform: 'translate(-50%)',
    bottom: 'auto',
  },
  overlay: {
    backgroundColor: 'transparent',
    zIndex: '3',
  },
};

class FormDeleteOrder extends Component {
  submit = (values) => {
    const { order, defaultAccount, token, auth } = this.props;

    console.log(defaultAccount, token, auth);
    const uuid = uuidv4();
    const params = {
      group: 'CORE',
      user: token.user,
      session: token.session,
      cmd: 'CancelOrder',
      type: auth.type,
      token: auth.token,
      rqId: uuid,
      channel: 'WTS',
      data: {
        origOrdrNo: order.ordrNo + '',
        acntNo: defaultAccount.acntNo,
        subAcntNo: order.subAcntNo,
      },
    };

    this.props.handleSubmitOrder(params);
    // this.props.reset();
  };

  render() {
    const {
      handleSubmit,
      submitting,
      showModal,
      handleCloseModal,
      order,
      t,
    } = this.props;

    return (
      <ReactModal
        isOpen={showModal}
        contentLabel="onRequestClose Example"
        onRequestClose={handleCloseModal}
        shouldCloseOnOverlayClick={true}
        style={customStyles}
      >
        <Card>
          <Card.Header>
            <span>{t('txt-title-delete-confirm')}</span>
            <FaTimes
              onClick={handleCloseModal}
              style={{ position: 'absolute', top: '10px', right: '10px' }}
            />
          </Card.Header>
          <Card.Body>
            <form className="form-trade" onSubmit={handleSubmit(this.submit)}>
              <table className="table table-no-bordered">
                <tbody>
                  <tr>
                    <td className="fz-14 content-read">{t('txt-symbol')}</td>
                    <td className="fz-14 content-read font-weight-bold">
                      {order && order.symbol}
                    </td>
                  </tr>
                  <tr>
                    <td className="fz-14 content-read">{t('txt-type')}</td>
                    <td
                      className={
                        'fz-18 content-read text-uppercase font-weight-bold ' +
                        (order && (order.buySelTp === '1' ? 'i' : 'd'))
                      }
                    >
                      {order &&
                        (order.buySelTp === '1' ? t('txt-buy') : t('txt-sell'))}
                    </td>
                  </tr>
                  <tr>
                    <td className="fz-14 content-read">{t('txt-orderNo')}</td>
                    <td className="fz-14 content-read font-weight-bold">
                      {order && order.ordrNo}
                    </td>
                  </tr>
                  {/**
                  <tr>
                    <td className="fz-14 content-read">PIN</td>
                    <td>
                      <Field
                        name="pin"
                        type="password"
                        className="form-control input-order content-read text-uppercase fz-14"
                        placeholder="Nhập mã PIN"
                        autoFocus={true}
                        component={RenderInputOrder}
                        validate={[required]}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="fz-14 content-read">Lưu PIN</td>
                    <td>
                      <Field
                        name="savePin"
                        type="checkbox"
                        component="input"
                      />
                    </td>
                  </tr>
                  */}
                </tbody>
              </table>
              <div className="d-flex justify-content-center mt-2">
                <button
                  type="submit"
                  disabled={submitting}
                  className="btn font-weight-bold fz-14 ml-2 btn-order order-buy"
                >
                  {t('txt-accept')}
                </button>
                <button
                  type="button"
                  disabled={submitting}
                  onClick={handleCloseModal}
                  className="btn font-weight-bold fz-14 btn-order ml-2"
                >
                  {t('txt-cancel')}
                </button>
              </div>
            </form>
          </Card.Body>
        </Card>
      </ReactModal>
    );
  }
}

FormDeleteOrder = reduxForm({
  form: 'deleteOrder',
  enableReinitialize: true,
})(FormDeleteOrder);

const makeMapStateToProps = () => {
  const getToken = makeGetToken();
  const getDefaultAccount = makeGetDefaultAccount();
  const getAuth = makeGetAuth();

  const mapStateToProps = (state) => {
    return {
      token: getToken(state),
      defaultAccount: getDefaultAccount(state),
      auth: getAuth(state),
    };
  };
  return mapStateToProps;
};

FormDeleteOrder = connect(makeMapStateToProps)(FormDeleteOrder);

export default translate('translations')(FormDeleteOrder);
